import dayjs from "utils/dayjs"

export enum NavbarState {
    expanded = "expanded",
    collapsed = "collapsed"
}

export enum ApiServiceName {
    user = "svcuser",
    article = "svcarticle",
    asset = "svcasset",
    finance = "svcfinance",
    mail = "svcmail",
    file = "svcfile",
    data = "svcdata",
}

export enum ApiLinkRel {
    all = "all",
    default = "default",
    self = "self",
    new = "new",
    update = "update",
    bulkUpdate = "bulkUpdate",
    upsert = "upsert",
    partialUpdate = "partial_update",
    delete = "delete",
    cancel = "cancel",
    create = "create",
    import = "import",
    reactivate = "reactivate",
}

export enum ApiLinkEntity {
    user = "user",
    userMail = "userMail",
    userMails = "userMails",
    userLanguage = "userLanguage",
    userSettings = "userSettings",
    userRoles = "userRoles",
    article = "article",
    articleClass = "articleClass",
    articleAsset = "articleAsset",
    articleDescription = "articleDescription",
    articleInspectionSettings = "articleInspectionSettings",
    measurementSystem = "measurementSystem",
    productHierarchy = "productHierarchy",
    division = "division",
    request = "request",
    offer = "offer",
    offerStatus = "offerStatus",
    offerNumber = "offerNumber",
    offerDocument = "offerDocument",
    customerDocuments = "customerDocuments",
    asset = "asset",
    assetFinancialAndListPrice = "assetFinancialAndListPrice",
    lmid = "lmid",
    assetLmid = "assetLmid",
    assetCategory = "assetCategory",
    assetLocation = "assetLocation",
    importedAssetCategory = "importedAssetCategory",
    assetImport = "assetImport",
    assetImportItem = "assetImportItem",
    assetOverviewExport = "assetOverviewExport",
    assetType = "assetType",
    assetTypeValidation = "assetTypeValidation",
    assetDisposalDateValidation = "assetDisposalDateValidation",
    assetPurpose = "assetPurpose",
    assetReservation = "assetReservation",
    assetDocument = "assetDocument",
    assetCollection = "assetCollection",
    assetVersion = "assetVersion",
    assetProduct = "assetProduct",
    assetReadinessToSplit = "assetReadinessToSplit",
    assetDisplayStatus = "assetDisplayStatus",
    assetAcquisition = "assetAcquisition",
    assetInspection = "assetInspection",
    assetInspectionPair = "assetInspectionPair",
    inspectionPair = "inspectionPair",
    assetInspectionComment = "assetInspectionComment",
    assetInspectionReport = "assetInspectionReport",
    assetLabels = "assetLabels",
    assetMaintenance = "assetMaintenance",
    assetMaintenanceComplete = "assetMaintenanceComplete",
    assetOperationHours = "assetOperationHours",
    altArticleDescription = "altArticleDescription",
    bookValue = "bookValue",
    monthlyRentalCost = "monthlyRentalCost",
    splitAsset = "splitAsset",
    assetReactivation = "assetReactivation",
    assetReactivationAvailabilityDateBounds = "assetReactivationAvailabilityDateBounds",
    shippingDashboard = "shippingDashboard",
    assetImage = "assetImage",
    availabilityArticle = "availabilityArticle",
    availabilityAsset = "availabilityAsset",
    warehouse = "warehouse",
    warehouses = "warehouses",
    profitCenter = "profitCenter",
    stocktakingOrder = "stocktakingOrder",
    stocktakingOrderClose = "stocktakingOrderClose",
    stocktakingScopeReopen = "stocktakingScopeReopen",
    stocktakingScopeClose = "stocktakingScopeClose",
    stocktakingScopeComplete = "stocktakingScopeComplete",
    stocktakingNotScannedAssets = "stocktakingNotScannedAssets",
    stocktakingItem = "stocktakingItem",
    company = "company",
    sepoTagType = "sepoTagType",
    sepoTag = "sepoTag",
    file = "file",
    invoice = "invoice",
    invoiceDetails = "invoiceDetails",
    invoiceAssetAssignment = "invoiceAssetAssignment",
    invoiceCostCategory = "invoiceCostCategory",
    invoiceImportOperation = "invoiceImportOperation",
    invoiceErpImportOperation = "invoiceErpImportOperation",
    invoiceExcelImportOperation = "invoiceExcelImportOperation",
    invoiceImportItem = "invoiceImportItem",
    additionalLmidsToAssign = "additionalLmidsToAssign",
    assignmentAssetInfo = "assignmentAssetInfo",
    assetBookingView = "assetBookingView",
    bookingForSelectedAssets = "bookingForSelectedAssets",
    customer = "customer",
    customerCurrencies = "customerCurrencies",
    customerDetails = "customerDetails",
    customersDashboard = "customersDashboard",
    valuation = "valuation",
    valuationParameter = "valuationParameter",
    depreciation = "depreciation",
    localDepreciation = "localDepreciation",
    tenantLanguage = "tenantLanguage",
    tenantSettings = "tenantSettings",
    tenantSettingsLanguage = "tenantSettingsLanguage",
    tenantSettingsContacts = "tenantSettingsContacts",
    tenantSettingsEmployees = "tenantSettingsEmployees",
    tenantSettingsTermsAndConditions = "tenantSettingsTermsAndConditions",
    tenantSettingsDeliveryTerms = "tenantSettingsDeliveryTerms",
    tenantSettingsTextBuildingBlock = "tenantSettingsTextBuildingBlock",
    tenantSettingsInvoicePosition = "tenantSettingsInvoicePosition",
    tenantSettingsOrderType = "tenantSettingsOrderType",
    tenantSettingsTermOfPayment = "tenantSettingsTermOfPayment",
    tenantGlobalAssetOverview = "tenantGlobalAssetOverview",
    tenantSettingsGlobalAssetOverview = "tenantSettingsGlobalAssetOverview",
    tenantCountries = "tenantCountries",
    tenantCountryIsoNumericCode = "tenantCountryIsoNumericCode",
    financialFactors = "financialFactors",
    imputedInterestRatePeriod = "imputedInterestRatePeriod",
    depreciationPeriod = "depreciationPeriod",
    depreciationPeriodIfrs = "depreciationPeriodIfrs",
    assetCategoryDepreciation = "assetCategoryDepreciation",
    articleDepreciation = "articleDepreciation",
    evaluationParametersSettings = "evaluationParametersSettings",
    evaluationParametersPeriod = "evaluationParametersPeriod",
    evaluationParameter = "evaluationParameter",
    calculationDetails = "calculationDetails",
    calculationDetailsVersion = "calculationDetailsVersion",
    calculationVersionComment = "calculationVersionComment",
    saleCalculationDetailsVersionInfo = "saleCalculationDetailsVersionInfo",
    calculationDetailsExtended = "calculationDetailsExtended",
    calculationDetailsOverheadValidationReservationCart = "calculationDetailsOverheadValidationReservationCart",
    calculationDetailsOverheadValidationAsset = "calculationDetailsOverheadValidationAsset",
    salesCalculationReport = "salesCalculationReport",
    offerCalculation = "offerCalculation",
    financeAssetLmid = "financeAssetLmid",
    financeSupplierOrderNumber = "financeSupplierOrderNumber",
    financeInternalOrderNumber = "financeInternalOrderNumber",
    valuationStatus = "valuationStatus",
    assetOverviewReport = "assetOverviewReport",
    invoiceNumber = "invoiceNumber",
    referenceNumber = "referenceNumber",
    referenceValue = "referenceValue",
    referenceText = "referenceText",
    imputedInterest = "imputedInterest",
    reservation = "reservation",
    reservationCart = "reservationCart",
    reservationCartArticle = "reservationCartArticle",
    reservationCartAsset = "reservationCartAsset",
    reservationCartLock = "reservationCartLock",
    reservationCartConflict = "reservationCartConflict",
    reservationNumber = "reservationNumber",
    reservationStatus = "reservationStatus",
    reservationPurpose = "reservationPurpose",
    reservationDocument = "reservationDocument",
    reservationInvoice = "reservationInvoice",
    reservationPricingDetails = "reservationPricingDetails",
    reservationReopen = "reservationReopen",
    reservationComment = "reservationComment",
    downtimePeriod = "downtimePeriod",
    invoicePosition = "invoicePosition",
    invoiceInterval = "invoiceInterval",
    invoiceIntervalEndDate = "invoiceIntervalEndDate",
    calculationAdjustment = "calculationAdjustment",
    shippingOrderOverview = "shippingOrderOverview",
    shippingOrder = "shippingOrder",
    shippingOrderCart = "shippingOrderCart",
    shippingOrderCartStatus = "shippingOrderCartStatus",
    shippingOrderCartLock = "shippingOrderCartLock",
    shippingOrderCartTransport = "shippingOrderCartTransport",
    shippingOrderCartAsset = "shippingOrderCartAsset",
    shippingOrderCartManualPosition = "shippingOrderCartManualPosition",
    shippingOrderCartSegment = "shippingOrderCartSegment",
    pickingListReport = "pickingListReport",
    requestLocation = "requestLocation",
    loadingListReport = "loadingListReport",
    invoiceDraft = "invoiceDraft",
    invoiceDraftByDate = "invoiceDraftByDate",
    adHocInvoice = "adHocInvoice",
    adHocInvoiceDraft = "adHocInvoiceDraft",
    sendInvoiceToErp = "sendInvoiceToErp",
    collectiveCreditNote = "collectiveCreditNote",
    label = "label",
    labelGroup = "labelGroup",
    labelGroupLink = "labelGroupLink",
    labelGroupLocation = "labelGroupLocation",
    labelId = "labelId",
    labelsOverview = "labelsOverview",
    labelCategory = "labelCategory",
    labelsDashboard = "labelsDashboard",
    documentCategory = "documentCategory",
    ztsSyncManual = "ztsSyncManual",
    ztsLastSyncState = "ztsLastSyncState",
    interfaceStatus = "interfaceStatus",
    assetIncomingInvoiceInfo = "assetIncomingInvoiceInfo",
    assetOutgoingInvoiceInfo = "assetOutgoingInvoiceInfo",
    notification = "notification",
    monthlyClosing = "monthlyClosing",
    forecastReport = "forecastReport",
    bookingPeriod = "bookingPeriod",
    acquisitionDisposalForecastReport = "acquisitionDisposalForecastReport",
    monthlyClosingEvaluationListReport = "monthlyClosingEvaluationListReport",
    monthlyClosingStplInputDataReport = "monthlyClosingStplInputDataReport",
    rentalReport = "rentalReport",
    asyncOperationStatus = "asyncOperationStatus",
    specialDepreciation = "specialDepreciation",
    specialDepreciationBookValue = "specialDepreciationBookValue",
    disposedByUserMail = "disposedByUserMail",
    fairValueEvaluation = "fairValueEvaluation",
    fairValueEvaluationPeriod = "fairValueEvaluationPeriod",
    referenceNumberSaleEstimateNetSalePrice = "referenceNumberSaleEstimateNetSalePrice",
    referenceNumberSaleEstimate = "referenceNumberSaleEstimate",
    fairValueFactors = "fairValueFactors",
    assetFairValueEvaluation = "assetFairValueEvaluation",
    referenceNumberSaleFairValueEvaluation = "referenceNumberSaleFairValueEvaluation",
    taxBasedDeduction = "taxBasedDeduction",
    overheadFactorsSettings = "overheadFactorsSettings",
    overheadFactorsPeriod = "overheadFactorsPeriod",
    overheadFactor = "overheadFactor",
    fullCreditNote = "fullCreditNote",
    partialCreditNote = "partialCreditNote",
    partialDebitNote = "partialDebitNote",
    assetCategoriesAndDivisions = "assetCategoriesAndDivisions",
    orderAcknowledgementReport = "orderAcknowledgementReport",
    rentalContract = "rentalContract",
    erpInvoiceSync = "erpInvoiceSync",
    erpInvoicesSync = "erpInvoicesSync",
    color = "color",
    collectiveReferenceNumber = "collectiveReferenceNumber",
    collectiveRefNumberRule = "collectiveRefNumberRule",
    supplier = "supplier",
    rentToBuyEvent = "rentToBuyEvent",
    configurationExport = "configurationExport",
    commission = "commission",
    downloadFileZip = "downloadFileZip",
    autocomplete = "autocomplete",
    userProfitCenter = "userProfitCenter",
    unblockCustomers = "unblockCustomers",
    refreshCustomer = "refreshCustomer",
    globalAssetOverview = "globalAssetOverview",
    globalAssetOverviewAutocomplete = "globalAssetOverviewAutocomplete",
    maintenanceType = "maintenanceType",
    exchangeRate = "exchangeRate",
    cmmText = "cmmText",
    workingDaysCalendar = "workingDaysCalendar",
    holiday = "holiday",
    resubmitInvoice = "resubmitInvoice",
    editInvoiceOrderNumber = "editInvoiceOrderNumber",
    deleteInvoice = "deleteInvoice",
    invoiceByOrderNumber = "invoiceByOrderNumber",
}

export enum ArticleTypeBasic {
    machine = "machine",
    equipment = "equipment"
}


export enum ArticleType {
    machine = "machine",
    equipment = "equipment",
    zts = "zts"
}

export enum ArticleSearchScope {
    machine = "m",
    equipment = "e"
}

export const ArticleSearchScopeToLabelMap = {
    [ArticleSearchScope.machine]: "common.machines",
    [ArticleSearchScope.equipment]: "common.equipment"
}

export enum ManufacturerType {
    liebherr = "liebherr",
    other = "other"
}

export enum MeasurementSystem {
    metric = "M",
    imperial = "I"
}

export enum MailRequestType {
    lhMachineArticle = "reqNewLHMachineArticle",
    productCategory = "reqNewProductCategory"
}

export enum Purpose {
    rent = "rent",
    sale = "sale",
    bridge = "bridge",
    demo = "demo",
    internalUse = "internalUse",
    relocation = "relocation",
}

export enum SchedulerScale {
    minutes = "minutes",
    hours = "hours",
    days = "days",
    weeks = "weeks",
    months = "months",
    quarters = "quarters"
}

export enum EventType {
    notAvailableArticle = "notAvailableArticle",
    notAvailableAsset = "notAvailableAsset",
    creating = "creating",
    reservation = "reservation",
    relocation = "relocation",
    sale = "sale",
    disposal = "disposal"
}

export enum AvailabilityPeriodUnit {
    minute = "minute",
    hour = "hour",
    day = "day",
    week = "week",
    month = "month",
    year = "year"
}

export enum GroupedControl {
    top = "top",
    bottom = "bottom",
    left = "left",
    right = "right",
    center = "center",
}

export enum SepoCategory {
    nonLhManufacturer = "nonLhManufacturer",
    lhManufacturer = "lhManufacturer",
    articles = "articles",
    inventory = "inventory",
    supplier = "supplier",
}

export enum SepoTagType {
    name = "name",
    articleNumber = "articleNumber",
    description = "description",
    feature = "feature",
}

export enum AggregateBy {
    article = "article",
    asset = "asset"
}

export enum FileType {
    jpeg = "jpeg",
    png = "png",
    gif = "gif",
    txt = "txt",
    pdf = "pdf",
    rtf = "rtf",
    msOffice = "msOffice",
    msOfficeLegacy = "officeLegacy"
}

export const FileTypeHeader = {
    [FileType.jpeg]: ["ffd8ffe0", "ffd8ffe1", "ffd8ffe2", "ffd8ffe3", "ffd8ffe8", "ffd8ffdb"],
    [FileType.png]: ["89504e47"],
    [FileType.gif]: ["47494638"],
    [FileType.txt]: ["74657374"],
    [FileType.pdf]: ["25504446"],
    [FileType.rtf]: ["7b5c7274"],
    [FileType.msOffice]: ["504b34"],
    [FileType.msOfficeLegacy]: ["d0cf11e0"],
}

export const TEMP_LMID_PREFIX = "PLAN:"

export const INTERNAL_ORDER_NUMBER_MAX_LENGTH = 15

export const INT32_MAX_VALUE = 2147483647
export const INVENTORY_OVERVIEW_MARKERS_MAX_COUNT = 5000
export const MODAL_MIN_ZINDEX = 900
export const EVENT_STEP = 15
export const EVENT_STEP_UNIT = "minutes"

export const INPUT_MAX_LENGTH_DEFAULT = 255
export const INPUT_MAX_LENGTH_LARGE = 65535

export const IMAGE_UPLOAD_MAX_SIZE_MB = 10
export const IMAGE_SUPPORTED_TYPES = [FileType.jpeg, FileType.png, FileType.gif]
export const IMAGE_INPUT_FILE_ACCEPT = ["image/jpeg", "image/png", "image/gif"]
export const IMAGE_SUPPORTED_TYPES_LABEL = "JPEG, JPG, PNG, GIF"
export const IMAGE_SUPPORTED_EXTENSIONS = [".jpeg", ".jpg", ".jpe", ".png", ".gif"]

export const DOCUMENT_UPLOAD_MAX_SIZE_MB = 50
export const DOCUMENT_SUPPORTED_TYPES = [FileType.txt, FileType.pdf, FileType.rtf, FileType.msOffice, FileType.msOfficeLegacy, FileType.jpeg, FileType.png, FileType.gif]
export const DOCUMENT_INPUT_FILE_ACCEPT = ["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/vnd.oasis.opendocument.text", "text/plain", "application/rtf", "application/vnd.ms-powerpoint", "application/vnd.openxmlformats-officedocument.presentationml.presentation", "application/vnd.oasis.opendocument.presentation", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "image/jpeg", "image/png", "image/gif"]
export const DOCUMENT_SUPPORTED_TYPES_LABEL = "pdf, doc, docx, odt, txt, rtf, ppt, pptx, odp, xls, xlsx, jpeg, jpg, jpe, png, gif"
export const DOCUMENT_SUPPORTED_EXTENSIONS = [".pdf", ".doc", ".docx", ".odt", ".txt", ".rtf", ".ppt", ".pptx", ".odp", ".xls", ".xlsx", ".jpeg", ".jpg", ".jpe", ".png", ".gif"]

export const FULL_CREDIT_NOTE_TEXT_LINE_BREAK_AFTER = 55
export const PARTIAL_CREDIT_NOTE_TEXT_LINE_BREAK_AFTER = 55

export const INVENTORY_ASSET_EXPORT_MAX_COUNT = 17000

export const MAX_ITEMS_PER_PAGE = 1000

export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000"

export enum ErrorCode {
    requestCanceled = "requestCanceled",
    notFound = "notFound",
    systemError = "systemError",
    unknownError = "unknownError",
    conflict = "conflict",
    unprocessableEntity = "unprocessableEntity",
    forbidden = "forbidden",
    locked = "locked",
}

export const EditSessionDuration = dayjs.duration(44, "minutes")
export const EditSessionConfirmModalDuration = dayjs.duration(1, "minute")

export enum FilterCategory {
    all = "all",
    articleType = "articleType",
    articleNumber = "articleNumber",
    productLine = "productLine",
    productFamily = "productFamily",
    productModel = "productModel",
    yearOfConstruction = "yearOfConstruction",
    assetPurpose = "assetPurpose",
    emissionLevel = "emissionLevel",
    lmid = "lmid",
    manufacturerCode = "manufacturerCode",
    inventoryNumber = "inventoryNumber",
    serialNumber = "serialNumber",
    serialNumberMachine = "serialNumberMachine",
    drawingNumber = "drawingNumber",
    internalOrderNumber = "internalOrderNumber",
    supplierOrderNumber = "supplierOrderNumber",
    assetLifeCycle = "assetLifeCycle",
    financeAssetLmid = "financeAssetLmid",
    financeSupplierOrderNumber = "financeSupplierOrderNumber",
    financeInternalOrderNumber = "financeInternalOrderNumber",
    valuationStatus = "valuationStatus",
    invoiceNumber = "invoiceNumber",
    referenceNumber = "referenceNumber",
    referenceText = "referenceText",
    assignmentStatus = "assignmentStatus",
    customerName = "customerName",
    customerNameSearch = "customerNameSearch",
    customerNumber = "customerNumber",
    crmReferenceNumber = "crmReferenceNumber",
    vatCode = "vatCode",
    operationalState = "operationalState",
    connectedAssets = "connectedAssets",
    condition = "condition",
    ownershipType = "ownershipType",
    reservationNumber = "reservationNumber",
    reservationNumberAssetIds = "reservationNumberAssetIds",
    availability = "availability",
    reservationStatus = "reservationStatus",
    reservationPurpose = "reservationPurpose",
    salesAdmin = "salesAdmin",
    salesPerson = "salesPerson",
    homebase = "homebase",
    warehouse = "warehouse",
    reservationWarehouse = "reservationWarehouse",
    responsibleWarehouse = "responsibleWarehouse",
    color = "color",
    shippingOrderType = "shippingOrderType",
    shippingOrderState = "shippingOrderState",
    shippingOrderNumber = "shippingOrderNumber",
    stateOfStorage = "stateOfStorage",
    outgoingInvoiceType = "outgoingInvoiceType",
    erpOrderNumber = "erpOrderNumber",
    erpInvoiceNumber = "erpInvoiceNumber",
    outgoingInvoiceStatus = "outgoingInvoiceStatus",
    automaticInvoicing = "automaticInvoicing",
    notificationChannel = "notificationChannel",
    notificationType = "notificationType",
    offerNumber = "offerNumber",
    offerPurpose = "offerPurpose",
    offerStatus = "offerStatus",
    shortage = "shortage",
    startsWithinDays = "startsWithinDays",
    endsWithinDays = "endsWithinDays",
    profitCenter = "profitCenter",
    disposalDateDiffersCreationPeriod = "disposalDateDiffersCreationPeriod",
    disposalDateDiffersInvoicePeriod = "disposalDateDiffersInvoicePeriod",
    invoiceDateDiffersCreationPeriod = "invoiceDateDiffersCreationPeriod",
    invoicePendingMoreThanDays = "invoicePendingMoreThanDays",
    articleClass = "articleClass",
    initialCondition = "initialCondition",
    availabilityDate = "availabilityDate",
    lastScanDate = "lastScanDate",
    dimensions = "dimensions",
    length = "length",
    width = "width",
    height = "height",
    volume = "volume",
    quickCoupler = "quickCoupler",
    connectionType = "connectionType",
    cuttingEdge = "cuttingEdge",
    teeth = "teeth",
    heavyDuty = "heavyDuty",
    locking = "locking",
    controlSystem = "controlSystem",
    agility = "agility",
    referenceNumberSale = "referenceNumberSale",
    referenceNumberRental = "referenceNumberRental",
    costCategory = "costCategory",
    fromToLocation = "fromToLocation",
    shippingOrderCompleteMode = "shippingOrderCompleteMode",
    label = "label",
    labelIdLinked = "labelId",
    labelIdNotLinked = "labelIdNotLinked",
    labelArticleNumber = "labelArticleNumber",
    labelSerialNumber = "labelSerialNumber",
    labelSerialNumberMachine = "labelSerialNumberMachine",
    labelInventoryNumber = "labelInventoryNumber",
    labelManufacturerCode = "labelManufacturerCode",
    labelConstructionYear = "labelConstructionYear",
    labelDrawingNumber = "labelDrawingNumber",
    labelCategory = "labelCategory",
    labelStatus = "labelStatus",
    user = "user",
    role = "role",
    invoiceDate = "invoiceDate",
    maxDistance = "maxDistance",
    assetCategory = "assetCategory",
    division = "division",
    tenant = "tenant",
    maintenanceType = "maintenanceType",
    maintenanceStatus = "maintenanceStatus",
    missingDepreciationRate = "missingDepreciationRate",
    lastInvoice = "lastInvoice",
    invoiceBeforeShipping = "invoiceBeforeShipping",
    invoiceBlocked = "invoiceBlocked",
    rentToBuy = "rentToBuy",
    assetType = "assetType",

    article = "article",
    asset = "asset"
}

export const OneTimeApplicableFilters = [
    FilterCategory.all,
    FilterCategory.articleType,
    FilterCategory.startsWithinDays,
    FilterCategory.endsWithinDays,
    FilterCategory.customerNameSearch,
    FilterCategory.shippingOrderCompleteMode,
]

export const FilterCategoryToLabelMap = {
    [FilterCategory.all]: "filter.all",
    [FilterCategory.articleType]: "filter.articleType",
    [FilterCategory.articleNumber]: "filter.article",
    [FilterCategory.productLine]: "filter.productLine",
    [FilterCategory.productFamily]: "filter.productFamily",
    [FilterCategory.productModel]: "filter.productModel",
    [FilterCategory.yearOfConstruction]: "filter.yearOfConstruction",
    [FilterCategory.labelConstructionYear]: "filter.yearOfConstruction",
    [FilterCategory.assetPurpose]: "filter.purpose",
    [FilterCategory.homebase]: "filter.homebase",
    [FilterCategory.warehouse]: "filter.warehouse",
    [FilterCategory.responsibleWarehouse]: "filter.responsibleWarehouse",
    [FilterCategory.profitCenter]: "filter.profitCenter",
    [FilterCategory.reservationWarehouse]: "filter.warehouse",
    [FilterCategory.emissionLevel]: "filter.emissionLevel",
    [FilterCategory.lmid]: "filter.lmid",
    [FilterCategory.manufacturerCode]: "filter.manufacturerCode",
    [FilterCategory.labelManufacturerCode]: "filter.manufacturerCode",
    [FilterCategory.inventoryNumber]: "filter.inventoryNumber",
    [FilterCategory.labelInventoryNumber]: "filter.inventoryNumber",
    [FilterCategory.serialNumber]: "filter.serialNumber",
    [FilterCategory.labelSerialNumber]: "filter.serialNumber",
    [FilterCategory.serialNumberMachine]: "filter.serialNumberMachine",
    [FilterCategory.labelSerialNumberMachine]: "filter.serialNumberMachine",
    [FilterCategory.financeAssetLmid]: "filter.lmid",
    [FilterCategory.financeSupplierOrderNumber]: "filter.supplierOrderNumber",
    [FilterCategory.financeInternalOrderNumber]: "filter.internalOrderNumber",
    [FilterCategory.valuationStatus]: "filter.valuationStatus",
    [FilterCategory.invoiceNumber]: "filter.invoiceNumber",
    [FilterCategory.referenceNumber]: "filter.referenceNumber",
    [FilterCategory.referenceText]: "filter.referenceText",
    [FilterCategory.assignmentStatus]: "filter.assignmentStatus",
    [FilterCategory.customerName]: "filter.customerName",
    [FilterCategory.customerNameSearch]: "filter.customerName",
    [FilterCategory.customerNumber]: "filter.customerNumber",
    [FilterCategory.crmReferenceNumber]: "filter.crmReferenceNumber",
    [FilterCategory.vatCode]: "filter.vatCode",
    [FilterCategory.drawingNumber]: "filter.drawingNumber",
    [FilterCategory.labelDrawingNumber]: "filter.drawingNumber",
    [FilterCategory.internalOrderNumber]: "filter.internalOrderNumber",
    [FilterCategory.supplierOrderNumber]: "filter.supplierOrderNumber",
    [FilterCategory.assetLifeCycle]: "filter.assetStatus",
    [FilterCategory.operationalState]: "filter.operationalState",
    [FilterCategory.connectedAssets]: "filter.connectedAssets",
    [FilterCategory.condition]: "filter.condition",
    [FilterCategory.ownershipType]: "filter.ownership",
    [FilterCategory.reservationNumber]: "filter.requestNo",
    [FilterCategory.reservationNumberAssetIds]: "filter.requestNo",
    // Renamed from Availability to Planning state
    [FilterCategory.availability]: "filter.planningState",
    [FilterCategory.reservationStatus]: "filter.state",
    [FilterCategory.reservationPurpose]: "filter.purpose",
    [FilterCategory.salesAdmin]: "filter.salesAdmin",
    [FilterCategory.salesPerson]: "filter.salesPerson",
    [FilterCategory.color]: "filter.color",
    [FilterCategory.shippingOrderType]: "filter.type",
    [FilterCategory.shippingOrderState]: "filter.state",
    [FilterCategory.shippingOrderNumber]: "filter.shippingOrderNumber",
    [FilterCategory.stateOfStorage]: "filter.stateOfStorage",
    [FilterCategory.outgoingInvoiceType]: "filter.type",
    [FilterCategory.erpOrderNumber]: "filter.orderNo",
    [FilterCategory.erpInvoiceNumber]: "filter.invoiceNumber",
    [FilterCategory.outgoingInvoiceStatus]: "filter.state",
    [FilterCategory.automaticInvoicing]: "filter.automaticInvoicing.title",
    [FilterCategory.notificationChannel]: "filter.channel",
    [FilterCategory.notificationType]: "filter.notificationType",
    [FilterCategory.offerNumber]: "filter.offerNo",
    [FilterCategory.offerPurpose]: "filter.purpose",
    [FilterCategory.offerStatus]: "filter.state",
    [FilterCategory.shortage]: "filter.shortage",
    [FilterCategory.missingDepreciationRate]: "filter.missingDepreciationRate",
    [FilterCategory.startsWithinDays]: "filter.start",
    [FilterCategory.endsWithinDays]: "filter.end",
    [FilterCategory.articleClass]: "filter.articleClass",
    [FilterCategory.initialCondition]: "filter.initialCondition",
    // Renamed label from Availability date to Initial availability
    [FilterCategory.availabilityDate]: "filter.initialAvailability",
    [FilterCategory.lastScanDate]: "filter.lastScanDate",
    [FilterCategory.dimensions]: "filter.dimensions",
    [FilterCategory.length]: "filter.length",
    [FilterCategory.width]: "filter.width",
    [FilterCategory.height]: "filter.height",
    [FilterCategory.volume]: "filter.volume",
    [FilterCategory.quickCoupler]: "filter.quickCoupler",
    [FilterCategory.connectionType]: "filter.connectionType",
    [FilterCategory.cuttingEdge]: "filter.cuttingEdge",
    [FilterCategory.teeth]: "filter.teeth",
    [FilterCategory.heavyDuty]: "filter.heavyDuty",
    [FilterCategory.locking]: "filter.locking",
    [FilterCategory.controlSystem]: "filter.controlSystem",
    [FilterCategory.agility]: "filter.agility",
    [FilterCategory.referenceNumberSale]: "filter.referenceNumberSale",
    [FilterCategory.referenceNumberRental]: "filter.referenceNumberRental",
    [FilterCategory.costCategory]: "filter.costCategory",
    [FilterCategory.fromToLocation]: "filter.fromToLocation",
    [FilterCategory.shippingOrderCompleteMode]: "filter.releaseStoreMode",
    [FilterCategory.label]: "filter.label.title",
    [FilterCategory.labelIdLinked]: "filter.labelId",
    [FilterCategory.labelIdNotLinked]: "filter.labelId",
    [FilterCategory.labelArticleNumber]: "filter.labelArticleNumber",
    [FilterCategory.labelCategory]: "filter.labelCategory",
    [FilterCategory.labelStatus]: "filter.labelStatus",
    [FilterCategory.user]: "filter.user",
    [FilterCategory.role]: "filter.role",
    [FilterCategory.invoiceDate]: "filter.invoiceDate",
    [FilterCategory.maxDistance]: "filter.maxDistance",
    [FilterCategory.tenant]: "filter.tenant",
    [FilterCategory.assetCategory]: "filter.assetCategory",
    [FilterCategory.division]: "filter.division",
    [FilterCategory.maintenanceType]: "filter.maintenanceType",
    [FilterCategory.maintenanceStatus]: "filter.status",
    [FilterCategory.lastInvoice]: "filter.lastInvoice",
    [FilterCategory.invoiceBeforeShipping]: "filter.invoiceBeforeShipping",
    [FilterCategory.invoiceBlocked]: "filter.invoiceBlock",
    // Rent-to-buy filter label (was previously using root key). Now nested under filter.* for consistency.
    [FilterCategory.rentToBuy]: "filter.rentToBuy",
    [FilterCategory.assetType]: "filter.assetType",

    [FilterCategory.article]: "filter.article",
    [FilterCategory.asset]: "filter.asset"
}

export const OutgoingInvoicesCreatedFilterCategories = [
    FilterCategory.reservationNumber,
    FilterCategory.reservationPurpose,
    FilterCategory.outgoingInvoiceType,
    FilterCategory.erpOrderNumber,
    FilterCategory.erpInvoiceNumber,
    FilterCategory.outgoingInvoiceStatus,
    FilterCategory.customerNumber,
    FilterCategory.customerName,
    FilterCategory.customerNameSearch,
    FilterCategory.salesAdmin,
    FilterCategory.article,
    FilterCategory.lmid,
    FilterCategory.profitCenter,
    FilterCategory.automaticInvoicing,
]

export const OutgoingInvoicesToBeCreatedFilterCategories = [
    FilterCategory.reservationNumber,
    FilterCategory.reservationPurpose,
    FilterCategory.customerNumber,
    FilterCategory.customerName,
    FilterCategory.customerNameSearch,
    FilterCategory.salesAdmin,
    FilterCategory.article,
    FilterCategory.lmid,
    FilterCategory.profitCenter,
    FilterCategory.automaticInvoicing,
]

// Cannot be decreased, only increased!
// Increase in case if the changes in the filters structure are uncapable with the current version.
// All existing filters allplied by the user will be cleared after the version change.
export const FiltersVersion = 4

export enum FilterStorage {
    inventory = "inventory",
    invoice = "invoice",
    valuation = "valuation",
    request = "request",
    fairValueEvaluation = "fairValueEvaluation",
    offer = "offer",
    outgoingInvoice = "outgoingInvoice",
    shippingOrder = "shippingOrder",
    notifications = "notifications",
    maintenance = "maintenance",
    customer = "customer",
}

// Cannot be decreased, only increased!
// Increase in case if the changes in the filters structure are uncapable with the current version
export const ViewSettingsVersion = 1

export enum ViewSettingsStorage {
    inventory = "inventory",
    requests = "requests",
    offers = "offers",
    shippingOrders = "shippingOrders",
    outgoingInvoices = "outgoingInvoices",
    incomingInvoices = "incomingInvoices",
    notifications = "notifications",
    linkLabels = "linkLabels",
    globalAssetOverview = "globalAssetOverview",
    maintenance = "maintenance",
    fairValueEvaluation = "fairValueEvaluation"
}

export enum StorageKey {
    signinRedirectURL = "signinRedirectURL",
    navbarState = "navbarState",
    filters = "filters",
    viewSettings = "viewSettings",
    scheduler = "scheduler",
}

export enum MapType {
    roadmap = "roadmap",
    hybrid = "hybrid"
}

export enum Currency {
    EUR = "EUR",
    USD = "USD",
    SEK = "SEK",
    HUF = "HUF",
    GBP = "GBP",
    AUD = "AUD",
    CHF = "CHF",
    CZK = "CZK",
    HKD = "HKD",
    SGD = "SGD",
    KRW = "KRW",
    JPY = "JPY",
    CNY = "CNY",
}

export enum AsyncReportState {
    inProgress = "inProgress",
    created = "created",
    canceledReportTooBig = "canceledReportTooBig",
    failed = "failed",
}

export enum SortDirection {
    asc = "asc",
    desc = "desc",
}

export enum UserPermission {
    AppSettingsView = "AppSettingsView",
    AppSettingsEdit = "AppSettingsEdit",
    TenantSettingsOtherShippingDetailsView = "TenantSettingsOtherShippingDetailsView",
    TenantSettingsOtherShippingDetailsEdit = "TenantSettingsOtherShippingDetailsEdit",
    TenantSettingsTermsOfDeliveryView = "TenantSettingsTermsOfDeliveryView",
    TenantSettingsTermsOfDeliveryEdit = "TenantSettingsTermsOfDeliveryEdit",
    TenantSettingsContactDetailsEdit = "TenantSettingsContactDetailsEdit",
    TenantSettingsEmployeesEdit = "TenantSettingsEmployeesEdit",
    TenantSettingsSupportedLanguagesEdit = "TenantSettingsSupportedLanguagesEdit",
    TenantSettingsWarehousesEdit = "TenantSettingsWarehousesEdit",
    TenantSettingsProfitCentersEdit = "TenantSettingsProfitCentersEdit",
    TenantSettingsMaintenanceView = "TenantSettingsMaintenanceView",
    TenantSettingsMaintenanceEdit = "TenantSettingsMaintenanceEdit",
    DeliveryNotesView = "DeliveryNotesView",
    ShippingOrdersView = "ShippingOrdersView",
    ShippingOrdersCreate = "ShippingOrdersCreate",
    ShippingOrdersEdit = "ShippingOrdersEdit",
    ShippingOrdersDelete = "ShippingOrdersDelete",
    ShippingOrdersForwardToShipping = "ShippingOrdersForwardToShipping",
    LoadingListsView = "LoadingListsView",
    LoadingListsEdit = "LoadingListsEdit",
    LabelsView = "LabelsView",
    LabelsLink = "LabelsLink",
    LabelCategoryView = "LabelCategoryView",
    LabelCategoryEdit = "LabelCategoryEdit",
    DocumentCategoryView = "DocumentCategoryView",
    DocumentCategoryEdit = "DocumentCategoryEdit",
    ArticleInspectionSettingsEdit = "ArticleInspectionSettingsEdit",
    AssetCreate = "AssetCreate",
    AssetEdit = "AssetEdit",
    AssetIdentificationFieldsEdit = "AssetIdentificationFieldsEdit",
    AssetStatusDependentEdit = "AssetStatusDependentEdit",
    AssetActiveStatusFieldsEdit = "AssetActiveStatusFieldsEdit",
    AssetConstructionYearEdit = "AssetConstructionYearEdit",
    AssetActiveConstructionYearEdit = "AssetActiveConstructionYearEdit",
    AssetActiveReferenceNumbersEdit = "AssetActiveReferenceNumbersEdit",
    AssignAssetToArticle = "AssignAssetToArticle",
    AssetView = "AssetView",
    AssetFinancialView = "AssetFinancialView",
    AssetSplit = "AssetSplit",
    ReactivateDisposedAssets = "ReactivateDisposedAssets",
    AssetAltArticleDescriptionEdit = "AssetAltArticleDescriptionEdit",
    AssetMaintenanceView = "AssetMaintenanceView",
    AssetMaintenanceEdit = "AssetMaintenanceEdit",
    StocktakingView = "StocktakingView",
    StocktakingCreate = "StocktakingCreate",
    StocktakingEdit = "StocktakingEdit",
    StocktakingDelete = "StocktakingDelete",
    DocumentsView = "DocumentsView",
    DocumentsCreate = "DocumentsCreate",
    DocumentsEdit = "DocumentsEdit",
    DocumentsDelete = "DocumentsDelete",
    OutgoingInvoicesCreate = "OutgoingInvoicesCreate",
    OutgoingInvoicesView = "OutgoingInvoicesView",
    AdHocInvoiceCreate = "AdHocInvoiceCreate",
    EvaluationParametersInHouseView = "EvaluationParametersInHouseView",
    EvaluationParametersInHouseEdit = "EvaluationParametersInHouseEdit",
    EvaluationParametersTradeAssetsView = "EvaluationParametersTradeAssetsView",
    EvaluationParametersTradeAssetsEdit = "EvaluationParametersTradeAssetsEdit",
    OverheadFactorsView = "OverheadFactorsView",
    OverheadFactorsEdit = "OverheadFactorsEdit",
    FinancialFactorsView = "FinancialFactorsView",
    FinancialFactorsEdit = "FinancialFactorsEdit",
    InvoicePositionsView = "InvoicePositionsView",
    InvoicePositionsEdit = "InvoicePositionsEdit",
    CollectiveReferenceNumbersEdit = "CollectiveReferenceNumbersEdit",
    CostCategoriesView = "CostCategoriesView",
    CostCategoriesEdit = "CostCategoriesEdit",
    DepreciationPeriodView = "DepreciationPeriodView",
    DepreciationPeriodEdit = "DepreciationPeriodEdit",
    AssetCategoriesEdit = "AssetCategoriesEdit",
    AssetTypesEdit = "AssetTypesEdit",
    FairValueEvaluationView = "FairValueEvaluationView",
    FairValueEvaluationCheck = "FairValueEvaluationCheck",
    FairValueFactorsView = "FairValueFactorsView",
    FairValueFactorsEdit = "FairValueFactorsEdit",
    TBDInHouseView = "TBDInHouseView",
    TBDInHouseEdit = "TBDInHouseEdit",
    TBDTradeAssetsView = "TBDTradeAssetsView",
    TBDTradeAssetsEdit = "TBDTradeAssetsEdit",
    DepreciationView = "DepreciationView",
    DepreciationEdit = "DepreciationEdit",
    OrderTypesView = "OrderTypesView",
    OrderTypesEdit = "OrderTypesEdit",
    ReservationPricingView = "ReservationPricingView",
    ReservationEdit = "ReservationEdit",
    ReservationChangeAssetTypeOnReleaseEdit = "ReservationChangeAssetTypeOnReleaseEdit",
    OfferEdit = "OfferEdit",
    IncomingInvoicesView = "IncomingInvoicesView",
    IncomingInvoicesEdit = "IncomingInvoicesEdit",
    AssignInvoiceAmountView = "AssignInvoiceAmountView",
    InvoicesImport = "InvoicesImport",
    EvaluationAsset = "EvaluationAsset",
    MonthlyClosing = "MonthlyClosing",
    CustomersDashboardView = "CustomersDashboardView",
    CustomerDocumentEdit = "CustomerDocumentEdit",
    RentToBuyEvents = "RentToBuyEvents",
    CalculationDetailsView = "CalculationDetailsView",
    UserProfitCenterEdit = "UserProfitCenterEdit",
    UserRolesEdit = "UserRolesEdit",
    TenantSettingsGlobalAssetOverviewView = "TenantSettingsGlobalAssetOverviewView",
    TenantSettingsGlobalAssetOverviewEdit = "TenantSettingsGlobalAssetOverviewEdit",
    GlobalAssetOverview = "GlobalAssetOverview",
}

export enum DurationType {
    days = "days",
    weeks = "weeks",
    months = "months",
    years = "years",
}

export enum InvoicingType {
    before = "before",
    after = "after",
}

export enum AutocompleteField {
    quickCouplingSystem = "quickCouplingSystem",
    connectionType = "connectionType",
    locking = "locking",
    controlSystem = "controlSystem",
    agility = "agility",
    referenceNumberSale = "referenceNumberSale",
    referenceNumberRental = "referenceNumberRental",
    emissionLevel = "emissionLevel",
    inventoryNumber = "inventoryNumber",
    serialNumber = "serialNumber",
    serialNumberMachine = "serialNumberMachine",
    manufacturerCode = "manufacturerCode",
    drawingNumber = "drawingNumber",
    shippingOrderNumber = "shippingOrderNumber",
    labelArticleNumber = "labelArticleNumber",
    labelSerialNumber = "labelSerialNumber",
    labelSerialNumberMachine = "labelSerialNumberMachine",
    labelInventoryNumber = "labelInventoryNumber",
    linkedLabelId = "linkedLabelId",
    notLinkedLabelId = "notLinkedLabelId",
    labelManufacturerCode = "labelManufacturerCode",
    labelConstructionYear = "labelConstructionYear",
    labelDrawingNumber = "labelDrawingNumber",
    erpInvoiceNumber = "erpInvoiceNumber",
    erpOrderNumber = "erpOrderNumber",
    customerNumber = "customerNumber",
    crmReferenceNumber = "crmReferenceNumber",
    customerName = "customerName",
    constructionYear = "constructionYear",
    vatCode = "vatCode",
    internalOrderNumber = "internalOrderNumber",
    supplierOrderNumber = "supplierOrderNumber",
}

export enum GlobalAssetOverviewAutocompleteField {
    locking = "locking",
    controlSystem = "controlSystem",
    agility = "agility",
    constructionYear = "constructionYear",
    emissionLevel = "emissionLevel",
    quickCouplingSystem = "quickCouplingSystem",
    connectionType = "connectionType",
    assetCategory = "assetCategory",
    division = "division",
}

export enum LoadingListFormat {
    pdf = "pdf",
    excel = "excel",
}

export enum TextVariable {
    InvoiceCounter = "{{InvoiceCounter}}",
    LMID = "{{LMID}}",
    ArticleDescription = "{{ArticleDescription}}",
    ConstructionYear = "{{ConstructionYear}}",
    SalesPersonName = "{{SalesPersonName}}",
    SalesPersonPhone = "{{SalesPersonPhone}}",
    SalesPersonEmail = "{{SalesPersonEmail}}",
    SalesAdminName = "{{SalesAdminName}}",
    SalesAdminPhone = "{{SalesAdminPhone}}",
    SalesAdminEmail = "{{SalesAdminEmail}}",
    ContactPersonName = "{{ContactPersonName}}",
    ContactPersonPhone = "{{ContactPersonPhone}}",
    ContactPersonEmail = "{{ContactPersonEmail}}",
    DeliveryAddress = "{{DeliveryAddress}}",
    CustomerName = "{{CustomerName}}",
    CustomerAddress = "{{CustomerAddress}}",
    StartDate = "{{StartDate}}",
    EndDate = "{{EndDate}}",
    Duration = "{{Duration}}",
    RequestNumber = "{{RequestNumber}}",
    OfferNumber = "{{OfferNumber}}",
    SerialNumber = "{{SerialNumber}}",
}

export enum TextVariableGroup {
    default = "default",
    withInvoiceCounter = "withInvoiceCounter",
    withInvoiceCounterRequest = "withInvoiceCounterRequest",
    withInvoiceCounterOffer = "withInvoiceCounterOffer",
    offerDocument = "offerDocument",
}
